export default {
  OPEN_TEXT_EDITOR: 'openTextEditor',
  CLOSE_TEXT_EDITOR: 'closeTextEditor',
  SET_FONT_FAMILY_DROPDOWN_OPENED: 'setFontFamilyDropdownOpen',
  SET_SELECTED_COMPONENT: 'setSelectedComponent',
  SET_SELECTED_COLOR: 'setSelectedColor',
  LOAD_FROM_WIDGET_DESIGN: 'loadFromWidgetDesign',
  CLEAR_WIDGET_DESIGN_STATE: 'clearWidgetDesignState',
};
